import React from 'react';

import { motion } from 'framer-motion';

interface BestOfHeaderProps {
  title: string;
  subtitle: string;
}

export default function BestOfHeader({ title, subtitle }: BestOfHeaderProps) {
  return (
    <>
      <motion.h1 
        className="text-4xl font-bold mb-4"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {title}
      </motion.h1>
      <motion.p 
        className="text-xl mb-8 text-gray-600 dark:text-gray-300"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        {subtitle}
      </motion.p>
    </>
  );
}